import {BetControlService} from '@gongxigames/framework/slotV2/services/BetControl/BetControlService';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {buyFeatureControlStore} from '@gongxigames/framework/slotV2/services/BuyFeatureBetControl/BuyFeatureControlStore';

export class BuyFeatureBetControlService extends BetControlService {
    public static NAME = 'BuyFeatureBetControlService';

    protected _currentBetValue = buyFeatureControlStore.buyFeature_bet;
    protected _currentBetFormatted = buyFeatureControlStore.buyFeature_betFormatted;
    protected _possibleBetValues = buyFeatureControlStore.buyFeature_betList;
    protected _betIndexBeforeStart = 0;
    protected _betIndex = 0;

    onSetupEvents(): void {
        super.onSetupEvents();

        this.emitter.on('UI.buyFeature.bet.increase', this.onChangeBet.bind(this, true));
        this.emitter.on('UI.buyFeature.bet.decrease', this.onChangeBet.bind(this, false));
        this.emitter.on('UI.buyFeature.bet.reSet', this.onReSetBet.bind(this));
        this.emitter.on('UI.buyFeature.bet.started', this.onBetStarted.bind(this));
        this.emitter.on('UI.buyFeature.bet.finished', this.onBetFinished.bind(this));
    }

    protected onGameInitialized(): void {
        super.onGameInitialized();

        this._betIndexBeforeStart = this._possibleBetValues.value.indexOf(slotStore.logic_defaultBet.value);
    };

    protected onReSetBet(): void {
        super.setByIndex(this.getUIBetIndex());
    }

    protected getUIBetIndex(): number {
        const bets = this._possibleBetValues.value;

        return bets.indexOf(slotStore.slot_bet.value);
    }

    protected setByIndex(index: number): void {
        this._betIndex = index;

        super.setByIndex(index);
    }

    protected onBetStarted(): void {
        this._betIndexBeforeStart = this.getUIBetIndex();
        this.emitter.emit('UI.bet.setByIndex', this._betIndex);
    }

    protected onBetFinished(): void {
        this.emitter.emit('UI.bet.setByIndex', this._betIndexBeforeStart);
    }
}